module.exports = __webpack_public_path__ + "img/card-prov-remedy-req-management.47c1bd3c.svg";